import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Seo, { serviceSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";
import PageHero from "../components/site/PageHero";
import Reveal from "../components/site/Reveal";
import FloorVisualizer from "../components/site/FloorVisualizer";
import DesignCarousel from "../components/site/DesignCarousel";
import FinalCTA from "../components/site/FinalCTA";
import { SERVICES_DATA } from "../lib/services";
import { IMG } from "../lib/site";

const Services = () => (
  <div>
    <Seo
      title="Floor Coating Services | Garage, Patio & Commercial | PRYME EPOXY"
      description="Polyaspartic and epoxy garage floors, patio coatings, concrete grind & seal, polished concrete and commercial coatings across Prescott, Flagstaff and Sedona."
      path="/services"
      jsonLd={serviceSchema("Floor Coatings", "Residential and commercial floor coating services in Northern Arizona.")}
    />
    <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]} />

    <PageHero
      overline="Our Services"
      title="Floors Built to Last a Lifetime"
      subtitle="Each service has its own page with full details. Pick the one that fits your project, or call Tyler and he'll point you in the right direction."
      image={IMG.blackGarage}
    />

    <section className="py-16 md:py-20 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES_DATA.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 3) * 0.06}>
            <Link to={`/services/${s.slug}`} className="group block border border-zinc-800 bg-[#141414] overflow-hidden h-full hover:border-[#C69453] transition-colors" data-testid={`service-card-${s.slug}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img src={s.image} alt={`${s.name} in Northern Arizona`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <span className="text-[#C69453] text-xs uppercase tracking-widest font-semibold">{s.category}</span>
                <h3 className="text-xl font-semibold text-white mt-1">{s.name}</h3>
                <p className="text-zinc-400 text-sm mt-2">{s.short}</p>
                <span className="inline-flex items-center gap-2 mt-4 text-[#C69453] font-semibold group-hover:gap-3 transition-all">
                  Learn more <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="pb-4 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="mb-8 text-center max-w-2xl mx-auto">
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Design Your Floor</span>
          <h2 className="text-3xl md:text-4xl font-light text-white mt-1">Picture Your Finish</h2>
        </div>
        <FloorVisualizer />
      </div>
    </section>

    <DesignCarousel />

    <section className="py-16 bg-zinc-950 border-y border-zinc-900">
      <div className="max-w-3xl mx-auto px-5 lg:px-12 text-center">
        <h2 className="text-2xl md:text-3xl font-light text-white mb-6">Every Floor Includes</h2>
        <div className="grid sm:grid-cols-3 gap-4 text-left">
          {["Free, transparent estimate", "Diamond-ground surface prep", "Residential lifetime warranty"].map((t) => (
            <div key={t} className="flex items-center gap-2 text-zinc-300 border border-zinc-800 bg-[#141414] p-4">
              <Check className="w-5 h-5 text-[#C69453] shrink-0" /><span className="text-sm">{t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

    <FinalCTA />
  </div>
);

export default Services;
